import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

const Confirm = () => {
    window.onload = function () {
        document.getElementById("osta").style.backgroundColor = "#FF8303"
    }

    const HandleSubmit = () => {
        localStorage.removeItem("CARD_CC")
        localStorage.removeItem("purchase_order")

        alert("Edukalt ostetud!")

        window.location.href = "/loputoo/index.html"
    }
    return (
        <div>
            <section class="gradient-main h-screen relative flex items-center justify-center overflow-hidden">
                <div class="mb-24 max-w-md mobile-fullscreen">
                    <h1 class="text-white font-title text-2xl  padding-left-mobile">3. Kinnita Ost</h1>
                    <div class="bg-color-2 p-8 rounded-md flex-none">

                        <div>
                            <h1 class="text-white font-title text-2xl">{JSON.parse(localStorage.getItem("purchase_order")).count}x Sunsett Sipper</h1>
                            <h2 class="text-white font-sec text-xl">Maitse: {JSON.parse(localStorage.getItem("purchase_order")).flavor}</h2>
                        </div>
                        <div class="flex border-t-3 border-b-3 border-t border-b border-white mt-2 items-center">
                            <img class="w-12 h-12" src={require("../../assets/icons8-card-100.png")} alt="" />
                            <h1 class="text-white text-2xl font-sec ml-4">{localStorage.getItem("CARD_CC")}</h1>
                        </div>

                        <button onClick={() => HandleSubmit()} class="btn bg-color-0 rounded-full relative p-2 w-96 mt-4 w-full-mobile">
                            <img class="absolute left-3 top-1.5" src={require("../../assets/icons8-shopping-cart-96 2.png")} alt="" />
                            <h1 class="text-white font-title text-xl">Osta</h1>
                        </button>
                    </div>
                </div>
            </section>

            <div class="absolute top-0 w-full">
                <Navbar></Navbar>
            </div>
            <div class="hide-on-mobile">
                <Footer isBottom={true}></Footer>
            </div>
        </div>
    )
}

export default Confirm;